import {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {ServiceAccountKeyStatus} from '@dms/api/security';
import i18n from '@dms/i18n';

type ServiceAccountKeyStatusFlagProps = Pick<FlagProps, 'label' | 'colorScheme'>;

export function getServiceAccountKeyStatusFlagProps(
  status: ServiceAccountKeyStatus
): ServiceAccountKeyStatusFlagProps {
  return match<ServiceAccountKeyStatus, ServiceAccountKeyStatusFlagProps>(status)
    .with('active', () => ({
      label: i18n.t('entity.serviceAccount.keyStatus.active'),
      colorScheme: 'green',
    }))
    .with('rotating', () => ({
      label: i18n.t('entity.serviceAccount.keyStatus.rotating'),
      colorScheme: 'orange',
    }))
    .with('expired', () => ({
      label: i18n.t('entity.serviceAccount.keyStatus.expired'),
      colorScheme: 'neutral',
    }))
    .exhaustive();
}
